"use client";

import { Shield, Scale, TriangleAlert, CircleX } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const commitments = [{
  icon: Shield,
  title: "Kejujuran",
  description: "Menjaga kejujuran terhadap klien dan lembaga peradilan"
}, {
  icon: TriangleAlert,
  title: "Konflik Kepentingan",
  description: "Menghindari segala bentuk konflik kepentingan"
}, {
  icon: Scale,
  title: "Keadilan Substantif",
  description: "Mengedepankan keadilan substantif di atas formalitas"
}, {
  icon: CircleX,
  title: "Anti Manipulasi",
  description: "Menolak rekayasa hukum, suap, atau praktik manipulatif"
}];
function CommitmentCard({
  commitment,
  index
}: {
  commitment: typeof commitments[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const Icon = commitment.icon;
  return <div ref={ref} data-index={index} className={`opacity-0 translate-y-5 transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : ""}`} style={{
    transitionDelay: `${index * 100}ms`
  }}>
      <Card className="bg-secondary border border-border hover:border-primary/50 hover:shadow-medium hover:-translate-y-1 transition-all duration-300 h-full">
        <CardContent className="flex flex-col items-center text-center gap-4 p-6">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon className="w-8 h-8 text-primary" strokeWidth={2} />
          </div>
          <h3 className="text-xl font-semibold text-foreground">
            {commitment.title}
          </h3>
          <p className="text-base text-muted-foreground leading-relaxed">
            {commitment.description}
          </p>
        </CardContent>
      </Card>
    </div>;
}
export default function Commitment() {
  return <section id="commitment" className="dark bg-background text-foreground py-20 px-4">
      <div className="max-w-screen-xl mx-auto">
        <h2 className="text-3xl font-bold text-foreground text-center mb-12">
          Komitmen Kami
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {commitments.map((commitment, i) => <CommitmentCard key={i} commitment={commitment} index={i} />)}
        </div>
      </div>
    </section>;
}